import React from "react";
import "./style.scss";

type ResultProps = {
  label?: string;
};

export const ResultHeader = (props: ResultProps) => {
  const { label } = props;
  return (
    <>
      <div className="resultHeader">{label}</div>
    </>
  );
};

export const ResultBody = (props: ResultProps) => {
  const { label } = props;
  return (
    <>
      <div className="resultBody">{label}</div>
    </>
  );
};
